export enum BasicRoutesEnum {
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
  CREATE_DEMO_ACCOUNT = '/create-demo-account',
  SIGN_UP_INVITE = '/invite',
  CONFIRM_RESET_PASSWORD = '/reset-password',
  RESET_PASSWORD = '/reset-password-request',
  LOG_OUT = '/log-out',
  OVERVIEW = '/:companyName/overview',
  GUARDS = '/:companyName/guards',
  SHIFTS = '/:companyName/shifts/:pageSection',
  ADMINS = '/:companyName/admins',
  LOCATIONS = '/:companyName/locations',
  SCHEDULE = '/:companyName/schedule/:pageSection',
  REPORTS = '/:companyName/reports',
  STATISTIC = '/:companyName/statistic/:pageSection',
  APP_PUBLISH = '/:companyName/app-publish',
  WHITE_LABEL = '/:companyName/white-label',
  GLOBAL_SEARCH = '/:companyName/global-search',
  ALERTS = '/:companyName/alerts',
  SETTINGS = '/:companyName/settings/:pageSection',
}
